import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../lib/api';

/** Client errors (4xx) are final; only transient failures are retried. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}

export const queryClient = createQueryClient();
